'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

exports.default = function (app) {
  app.directive('linked', function ($document, currentScope) {
    return function ($scope, $element, $attr) {
      var linkedId = $attr.linked;
      $element.on('click', function () {
        var modal = currentScope.getActiveModal();
        if (modal) {
          modal.querySelector('#' + linkedId).click();
        } else {
          var view = currentScope.getActiveView();
          if (view) {
            view.querySelector('#' + linkedId).click();
          }
        }
      });
    };
  });
  return app;
};

require('angular');

/**
 * 触发指定的button
 */

;


//////////////////
// WEBPACK FOOTER
// ./src/lib/angular1.x-common/directives/linked.js
// module id = 144
// module chunks = 0